<script>
import * as R from 'ramda'
import tap from 'tap-logger'

export default {
	props:[
		'headerCopy',
		'productsCopy',
		'totalCopy',
		'viewCartCopy',
		'cartPageLink',
		'goToShopCopy',
		'checkoutLink',
		'cart',
	],

	data() {
		return {
		}
	},

	methods: {
		removeFromCart(id) {
			let url = R.replace('__id__', id, this.$root.store.routes.removeFromCart.post || '/cart/delete-item/__id__')
			this.$http.post(url, {
				_method: 'DELETE',
				_token: this.$root.store.csrf_token
			})
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.$root.store.cart.data = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		toggleOpen() {
			this.$root.store.menus.cart.isOpen = !this.isOpen
		},

		open() {
			this.$root.store.menus.cart.isOpen = true
		},

		close() {
			this.$root.store.menus.cart.isOpen = false
		}
	},
	computed: {
		links() {
			let {cartIndex, checkout} = this.$root.store.routes.get
			return {cartIndex, checkout}
		},

		copies() {
			return this.$root.store.copies.menuCart
		},

		isOpen() {
			return this.$root.store.menus.cart.isOpen
		},

		totalPrice() {
			return R.pathOr('$0', ['cart', 'data', 'formated_total'], this)
		},

		subtotalPrice() {
			return R.pathOr('$0', ['cart', 'data', 'formated_subtotal'], this)
		},

		items() {
			return R.pathOr([], ['cart', 'data', 'items'], this)
		},

		totalQuantity() {
			return this.items.length
		},

		shownProducts() {
			return R.pipe(
				R.slice(0, 3),
				R.map(({item_id, thumbnail_url,name, description, formated_buyable_price, quantity,computed_description}) => ({
					id: item_id,
					img: thumbnail_url,
					description,
					name,
					price: formated_buyable_price,
					quantity,
					computed_description:computed_description
				})),
			)(this.items)
		}
	}
}
</script>

<template lang="pug">

section.menu-cart
	div.elements(v-on:click.stop="toggleOpen")
		div.elements__buy(v-on:click.stop="toggleOpen")
			span.total-price {{copies.headerCopy}} {{totalPrice}}
			i.fa.fa-shopping-bag.header__navbar--carButtonTooltipContainer--icon(aria-hidden="true")
		.elements__buy--circle
			| {{totalQuantity}}
		.elements__buy--tooltip(v-if="isOpen", v-on:click.stop="")
			div.elements__scrollable-container
				p.elements__buy--ttl {{copies.productsCopy}}
				div.relative(v-for="product in shownProducts")
					.elements__buy--description
						.elements__buy--img
							img.elements__buy--img-size(:src="product.img")
						.elements__buy--txt
							p {{{product.name}}}
							p {{product.quantity}} x {{product.price}}
						.elements__buy--icon(v-on:click="removeFromCart(product.id)")
							i.fa.fa-times-circle(aria-hidden="true")
				.elements__buy--subtotal
					p {{copies.totalCopy}}
					p.elements__buy--price {{subtotalPrice}}
				.elements__buy--botones
					a(:href="links.cartIndex") {{copies.viewCartCopy}}
					a(:href="links.checkout") {{copies.goToShopCopy}}
</template>

<style lang="scss" scoped>
.elements {
	&__buy--icon i {
		padding: 5px;
		cursor: pointer;
		top: 5px;
		right: -2px;
	}

	&__scrollable-container {
		max-height: calc(100vh - 100px);
		overflow-y: auto;
		overflow-x: hidden;
		width: calc(100% + 20px);//espacio para la barra de scroll, si aparece
 	   	padding-right: 20px;
	}
}

</style>
